// Sample menu items for restaurant orders
export const menuItems = [
  { name: 'Chicken Biryani', price: 250, image: '/images/menu/Chicken-Biryani.jpg' },
  { name: 'Mutton Biryani', price: 300, image: '/images/menu/Mutton-Biryani.jpg' },
  { name: 'Veg Biryani', price: 200, image: '/images/menu/veg-biryani.jpg' },
  { name: 'Butter Chicken', price: 280, image: '/images/menu/butter-chicken.jpg' },
  { name: 'Dal Makhani', price: 180, image: '/images/menu/dal-makhani.jpg' },
  { name: 'Paneer Butter Masala', price: 220, image: '/images/menu/paneer-butter-masala.jpg' },
  { name: 'Chicken Curry', price: 240, image: '/images/menu/chicken-curry.jpg' },
  { name: 'Fish Curry', price: 260, image: '/images/menu/fish-curry.jpg' },
  { name: 'Roti', price: 15, image: '/images/menu/roti.jpg' },
  { name: 'Naan', price: 25, image: '/images/menu/naan.jpg' },
  { name: 'Rice', price: 80, image: '/images/menu/rice.jpg' },
  { name: 'Raita', price: 50, image: '/images/menu/raita.jpg' },
  { name: 'Salad', price: 60, image: '/images/menu/salad.jpg' },
  { name: 'Lassi', price: 40, image: '/images/menu/lassi.jpg' },
  { name: 'Tea', price: 20, image: '/images/menu/tea.jpg' },
  { name: 'Coffee', price: 30, image: '/images/menu/coffee.jpg' },
  { name: 'Cold Drink', price: 35, image: '/images/menu/cold-drink.jpg' },
  { name: 'Water Bottle', price: 20, image: '/images/menu/water-bottle.jpg' },
];

export const getMenuItems = () => menuItems;
